import { Component } from '@angular/core';

@Component({
  selector: 'app-work-orders-layout',
  template: `<router-outlet></router-outlet>`,
})
export class WorkOrdersLayoutComponent {}
